export default {
      id: "i-bpif-h-usage",
      viewBox: "0 0 108 82",
      url: __webpack_public_path__ + "img/sprite.svg#i-bpif-h",
      toString: function () {
        return this.url;
      }
    }